import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { SaveService } from '../../../services/save.service';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DialogService } from "../../../services/dialog.service";
import { Utils } from "../../../utils/utils";
import { Subject, filter } from "rxjs";
import { ChangeHistoryDialogue } from "../dialog-change-history/dialog-change-history";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: "customerdocument-list",
    templateUrl: './customerdocument-list.component.html',
    styleUrls: ['./customerdocument-list.component.less', '../../../style/mat-table.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ]
})

export class CustomerDocumentListComponent implements OnInit {

    @Input('list') list: CustomerDocument[] = [];
    @Input('showLocalFilter') showLocalFilter = false;

    columnsToDisplay = ['arrow-items', 'index', 'DocumentId', 'DocumentType', 'CustomerId', 'ContractNumber',
        'UnitId', '_ChangedAtUtc', 'actions'];
    subcolumnsToDisplay = ['DescriptionLocale', 'Amount', 'TaxAmount', 'IsBalanced', 'CreatedDateTime',
        'ExpiredDateTime', 'DocumentUri', 'MediaType', 'ExternalCategoryReference', 'LanguageCultureName',
        'IsDeleted'];

    booleanColumns = ['IsBalanced','IsDeleted']
    dateColumns = ['_ChangedAtUtc', 'CreatedDateTime', 'ExpiredDateTime']
    numberColumns = ['Amount', 'TaxAmount']

    notEditableColumns = ['DocumentId', 'CustomerId', 'ContractNumber', 'UnitId', '_ChangedAtUtc']

    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

    public dataSource = new MatTableDataSource<CustomerDocument>();
    selected: CustomerDocument | undefined;
    expanded: boolean[] = [];
    expandedElements = new Set();
    clonedItemsList: { [s: string]: CustomerDocument } = {};

    filter = '';

    subscriptionTenant: any;

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    protected _onDestroy = new Subject<void>();

    constructor(private http: HttpClient
        , private saveService: SaveService
        , private defaults: DefaultValuesService
        , @Inject('BASE_URL') public baseUrl: string
        , private confimDialog: DialogService
        , private dialog: MatDialog
        , private readonly toastrService: ToastrService
    ) {
    }

    ngOnChanges() {
        this.dataSource.data = this.list;
        this.clonedItemsList = {};
        this.saveService.showSaveButton(false);
        this.expandedElements.clear();
        this.saveService.addListener(this);
    }

    ngOnInit() {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader();
        });
        this.saveService.addListener(this);
        this.dataSource.filterPredicate = (data: CustomerDocument, filter: string) => {
            const matchFilter: any[] = [];
            const filterArray = filter.split('+').filter(x => x.indexOf('notextfilters') < 0);
            if (filterArray.length > 0) {
                filterArray.forEach((filterElement) => {
                    const fields: string[] = []
                    fields.push(data.DocumentId ? data.DocumentId : '')
                    fields.push(data.CustomerId ? data.CustomerId : '')
                    fields.push(data.ContractNumber ? data.ContractNumber : '')
                    fields.push(data.UnitId ? data.UnitId : '')
                    fields.push(data.DocumentType ? data.DocumentType : '')
                    return matchFilter.push(fields.some(item => item.includes(filterElement)));
                });
            }
            else {
                let result = true;
                matchFilter.push(result);
            }
            return matchFilter.some(Boolean);
        };
    }

    getHeader() {
        if (!this.defaults.isReadonlyUser)
            this.columnsToDisplay = ['arrow-items', 'index', 'DocumentId', 'CustomerId', 'ContractNumber',
                'UnitId', 'DocumentType', '_ChangedAtUtc', 'actions'];
        else 
            this.columnsToDisplay = ['arrow-items', 'index', 'DocumentId', 'CustomerId', 'ContractNumber',
                'UnitId', 'DocumentType', '_ChangedAtUtc'];
        this.subcolumnsToDisplay.sort((x, y) => (x > y ? 1 : -1));

    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    getInput(data: CustomerDocument, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = '';
        if (this.booleanColumns.indexOf(property) > -1) result = 'boolean';
        else if (this.dateColumns.indexOf(property) > -1) result = 'date';
        else if (this.numberColumns.indexOf(property) > -1) result = 'number'
        else result = 'string';
        return result;
    }

    changeElement(object: any, type: string, value: boolean) {
        object[type] = value;
        this.saveService.showSaveButton(true);
    }

    pushPopElement(element: CustomerDocument) {
        if (this.expandedElements.has(element)) {
            this.expandedElements.delete(element);
        } else {
            this.expandedElements.add(element);
            this.onExpand(element);
        }
    }

    checkExpanded(element: CustomerDocument) {
        return this.expandedElements.has(element);
    }

    onExpand(element: CustomerDocument) {
        Utils.httpGetDetailedCustomerDocument(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , element
            , this
            , function (tthis: any, list: CustomerDocumentDetails[]) {
                element.Details = list;
                tthis.expandedElements.add(element);
            }
        );
    }
    
    onRowEditInit(row: CustomerDocument) {
        this.saveService.addListener(this);
        this.clonedItemsList[this.getDictionaryHash(row)] = { ...row };
        if (Object.keys(this.clonedItemsList).length !== 0) this.saveService.showSaveButton(true);
        this.table.renderRows();
    }

    onRowEditCancel(row: CustomerDocument) {
        this.dataSource.data[this.dataSource.data.findIndex(x => x.TenantId === row.TenantId && x.DocumentId === row.DocumentId && x.CustomerId === row.CustomerId && x.ContractNumber === row.ContractNumber && x.UnitId === row.UnitId)] = this.clonedItemsList[this.getDictionaryHash(row)];
        delete this.clonedItemsList[this.getDictionaryHash(row)];
        if (Object.keys(this.clonedItemsList).length === 0) this.saveService.showSaveButton(false);
        this.table.renderRows();
    }

    isEditingRow(row: CustomerDocument, property: string) {
        return this.clonedItemsList[this.getDictionaryHash(row)]
            && (this.notEditableColumns.indexOf(property) < 0)
    }

    onShowSavebutton() {
        this.saveService.showSaveButton(true);
    }

    onSave() {
        const updatedList: any[] = [];
        for (let i in this.clonedItemsList) {
            const index = this.dataSource.data.findIndex(x => x.DocumentId === this.clonedItemsList[i].DocumentId);
            const obj = Utils.OmitKeysSpreadOperator(['Details'], this.dataSource.data[index]);
            let details = (this.dataSource.data[index] && Array.isArray(this.dataSource.data[index].Details) && this.dataSource.data[index].Details.length > 0)
                ? this.dataSource.data[index].Details[0]
                : {};
            let item = { ...details, ...obj };
            updatedList.push(Utils.RemoveBlankFields(item));
        }
        if (updatedList.length > 0)
            console.log('Updated List:', updatedList);
            Utils.httpUpdateCustomerDocuments(
                this.http
                , this.baseUrl
                , this.defaults.stage
                , updatedList
                , this
                , function (tthis: CustomerDocumentListComponent) {
                    tthis.toastrService.success('Customer Document(s) saved successfully!');
                    tthis.clonedItemsList = {};
                    tthis.saveService.showSaveButton(false);
                    tthis.expandedElements.clear();
                    tthis.table.renderRows();
                }
                , function (tthis: CustomerDocumentListComponent, message: string) {
                    tthis.saveService.addListener(tthis);
                    tthis.saveService.showSaveButton(true);
                    tthis.confimDialog.showErrorDialog(message);
                }
            );
    }

    applyFilter(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.searchItems.push({ name: value.replace('+', '').trim() });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.updatefilter()
    }

    remove(item: SearchItem): void {
        const index = this.searchItems.indexOf(item);
        if (index >= 0) {
            this.searchItems.splice(index, 1);
        }
        this.updatefilter()
    }

    updatefilter() {
        let filterString: string
        if (this.searchItems.length === 0) {
            this.dataSource.filter = 'notextfilters'
        }
        else {
            filterString = this.searchItems.map(e => { return e.name }).join('+') + '+checkboxes';
            this.dataSource.filter = filterString;
        }
            
    }

    getDictionaryHash(row: CustomerDocument) {
        return row.DocumentId + row.CustomerId + row.ContractNumber + row.UnitId;
    }

    getDateUTCChange(event, data: ContactInfoHub, property: string) {
        let utcDate = Utils.dateUTCchange(event);
        data[property] = utcDate;
    }
    openChangeHistoryDialog(element: any) {
        const filteredElement = element ? Object.fromEntries(
            Object.entries(element).filter(([key]) => this.columnsToDisplay.includes(key))
        ) : undefined;
        if (filteredElement) {
                filteredElement["TenantId"] = element.TenantId;
                filteredElement["UnitId"] = element.UnitId ?? '';
        }
        this.dialog.open(ChangeHistoryDialogue, {
            height: '535px',
            width: '900px',
            data: {
                entity: 'CustomerDocument',
                row: filteredElement,
            }
        });
    }
}
export interface SearchItem {
    name: string;
}